import { get } from "lodash";
import { BaseGridColumnModel } from "./types";
import { parseUntrustedHtmlAsPlaintext } from "../../utils/markup";

export const GridHtmlColumnTemplate = (
  columnModel: BaseGridColumnModel,
  data: object | undefined
) => {
  return (
    <div className="grid-html-column">
      {parseUntrustedHtmlAsPlaintext(get(data, columnModel.field ?? ""))}
    </div>
  );
};
